import template from './entity-categories-edit.html';
import './entity-categories-edit.less';
import EntityCategoriesEditController from './entity-categories-edit.controller';

const EntityCategoriesEditComponent = {
    template,
    bindings: {
        entityType: '@',
    },
    controller: [
        '$state',
        'crEntityCategoriesService',
        'crErrorLoggingService',
        'crImageService',
        'crNavigationService',
        '$uibModal',
        'crAnalyticsService',
        EntityCategoriesEditController,
    ],
};

export default EntityCategoriesEditComponent;
